import { FC } from "react"

export const DisabledInput: FC<{ value: string }> = (props) => {
    return <input className="fw form-control" value={props.value} disabled />
}
